module.exports = __webpack_public_path__ + "static/media/mlHorizontalVAH.e2b0308f.png";